// extracted by mini-css-extract-plugin
export default {"container":"InfiniteScroll_container__6xDir","loader":"InfiniteScroll_loader__ajapY"};